import { Button } from "@/components/ui/button";
import { WellyMark } from "@/components/WellyMark";

interface EmptyStateProps {
  icon?: React.ReactNode;
  /**
   * Render Welly above the title — the "came back empty" moment
   * (docs/BRAND.md). Ignored when an explicit `icon` is given.
   */
  welly?: boolean;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ icon, welly, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {icon && <div className="mb-4 text-muted-foreground">{icon}</div>}
      {!icon && welly && (
        <div className="mb-4 text-muted-foreground">
          <WellyMark size={56} />
        </div>
      )}
      <h3 className="text-lg font-semibold">{title}</h3>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      {action && (
        <Button className="mt-4" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
